// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Phone: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 42 42"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M41.117 31.289c-2.444-1.499-5.357-3.235-8.411-4.763-.78-.387-1.942-.58-3.027.72-.768.916-1.639 1.798-2.394 2.553-1.553 1.556-1.652 1.569-3.592.544-5.083-2.695-9.047-6.673-11.804-11.827-.845-1.575-.839-1.6.487-2.904.551-.538 1.188-1.17 1.763-1.858.585-.693 1.312-1.77.897-3.078-.978-3.06-2.003-6.038-2.955-8.798C11.67.695 10.767.082 9.294.011 5.965-.15 3.464 1.363 1.658 4.647c-2.214 4.022-2.21 8.374.007 12.947 5.794 11.926 13.764 19.5 24.37 23.159l.612.215c1.215.432 2.466.877 3.96 1.03l.038.002.285-.01c1.317-.05 2.807-.107 4.27-.588 4.196-1.381 6.475-4.042 6.778-7.91.041-.518.127-1.59-.865-2.199l.004-.004z"
            />
        </svg>
    );
};

export default React.memo(Phone);
